import requestv2 from "~/utils/http-v2";
const serviceApi = {
	get : async (id) => {
		const url = `v2/service/${id}`;
		return await requestv2.get(url);
	},
	gets : async (params) => {
		const url = 'v2/service';
		return await requestv2.get(url, {params});
	},
	search : async (params) => {
		const url = 'v2/service/search';
		return await requestv2.get(url, {params});
	},
	add : async (params) => {
		const url = `v2/service/${params.id}`;
		return await requestv2.post(url, params);
	},
	close : async (params) => {
		const url = `v2/service/close/${params.id}`;
		return await requestv2.post(url, params);
	},
	temporary : async (params) => {
		const url = `v2/service/temporary/${params.id}`;
		return await requestv2.post(url, params);
	},
	extend : async (params) => {
		const url = `v2/service/extend/${params.id}`;
		return await requestv2.post(url, params);
	},
	extendPa : async (id) => {
		const url = `v2/pavietnam/extend/${id}`;
		return await requestv2.post(url);
	},
	update : async (params) => {
		const url = `v2/service/update/${params.id}`;
		return await requestv2.post(url, params);
	},
	upgrade : async (params) => {
		const url = `v2/service/upgrade/${params.id}`;
		return await requestv2.post(url, params);
	},
	domains : async (id) => {
		const url = `v2/service/domain/${id}`;
		return await requestv2.get(url);
	},
	hostInfo : async (id) => {
		const url = `v2/service/host/${id}`;
		return await requestv2.get(url);
	},
	hostAdd : async (params) => {
		const url = `v2/service/host/${params.id}`;
		return await requestv2.post(url, params);
	},
	hostEdit : async (params) => {
		const url = `v2/service/host/${params.id}`;
		return await requestv2.patch(url, params);
	},
	updateDomain : async (params) => {
		const url = `v2/service/domain/${params.id}`;
		return await requestv2.post(url, params);
	},
	getNameserver : async (id) => {
		const url = `v2/service/domain/nameserver/${id}`;
		return await requestv2.get(url);
	},
	updateNameserver : async (params) => {
		const url = `v2/service/domain/nameserver/${params.id}`;
		return await requestv2.post(url, params);
	},
	useAllow : async (id) => {
		const url = `v2/service/use/allow/${id}`;
		return await requestv2.post(url);
	},
	useCancel : async (id) => {
		const url = `v2/service/use/cancel/${id}`;
		return await requestv2.post(url);
	},
};

export default serviceApi;